import React from 'react';

import { TableRowGrid } from 'components/table/models';
import { TableContainer } from 'components/table/styledElements/tableStyledElements';
import TableHeader from 'components/table/TableHeader';

import { TopicType } from '../../models';

import ModuleContainerRow from './ModuleContainerRow';

type Props = {
  isShowButtons: boolean;
  data: TopicType[];
};

const ModuleTable = ({ data, isShowButtons }: Props) => (
  <TableContainer>
    <TableHeader tableName={TableRowGrid.ContentModules} />
    {!!data.length && (
      <div>
        {data.map((item) => (
          <ModuleContainerRow
            isShowButtons={isShowButtons}
            item={item}
            key={item.id}
            openModalWindow={() => null}
          />
        ))}
      </div>
    )}
  </TableContainer>
);

export default ModuleTable;
